export default __webpack_public_path__ + "static/mo-a24fabee03c6b0003e6385ae8dee59f5.svg";